import React, { Component } from "react";
import "./../css/master.css";
import "./../css/internalPo.css";
import Header from "./../js/header.js";
import axiosInstance from '../api/csAxios';
import $ from "jquery";
import DatePicker from "react-datepicker";
//import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const { IMG_TYPES } = require("./imgType");

var httpURL = window.httpURL;
var queryString = require("querystring");

export default class CancelledIpoDesignReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allIpo: [],
      ipo: [],
      startDate: null,
      endDate: null,
      loader: "none",
      opacity: 1,
      width: "98.6%",
      width1: "98.6%",
      width2: "98.6%",
    };
  }

  getIpo = () => {
    var fromDt = $("#inp_fromDate").val();
    var toDt = $("#inp_toDate").val();
    if (Date.parse(this.state.startDate) > Date.parse(this.state.endDate)) {
      toast.warning("End Date should be greater than Start Date");
      return false;
    }
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/ipo/cancelled/list",
        queryString.stringify({ fromDt: fromDt, toDt: toDt }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            ipo: response.data.lstIpoCancelled,
            allIpo: response.data.lstIpoCancelled,
          });
        } else {
          toast.error(response.data.SvcMsg);
          if (response.data.SvcMsg == "No Internal PO exist")
            $("#ipoTableBody tr").remove();
          this.setState({ ipo: [], allIpo: [] });

          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  async componentDidMount() {
    this.handleResize();
    window.addEventListener("load", this.handleResize);
    window.addEventListener("resize", this.handleResize);

    var startDate = new Date();
    var startDate = startDate.setDate(startDate.getDate() - 60);
    await this.setState({
      startDate: new Date(startDate),
    });
    var endDate = new Date();
    var endDate = endDate.setDate(endDate.getDate());
    await this.setState({
      endDate: new Date(endDate),
    });
    this.getIpo();
  }

  handleResize = () => {
    var width = $(".tableLayout1").parent().width() - 18;
    var width1 = $(".tableLayout2").parent().width() - 18;
    var width2 = $(".tableLayout3").parent().width() - 18;
    this.setState({ width: width, width1: width1, width2: width2 });
  };

  getIpo = () => {
    var fromDt = $("#inp_fromDate").val();
    var toDt = $("#inp_toDate").val();
    if (Date.parse(this.state.startDate) > Date.parse(this.state.endDate)) {
      toast.warning("End Date should be greater than Start Date");
      return false;
    }
    var ipo = { fromDt: fromDt, toDt: toDt };
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/ipo/cancelled/list",
        queryString.stringify({ fromDt: fromDt, toDt: toDt }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            ipo: response.data.lstIpoCancelled,
            allIpo: response.data.lstIpoCancelled,
          });
        } else {
          toast.error(response.data.SvcMsg);
          if (response.data.SvcMsg == "No Internal PO exist")
            $("#ipoTableBody tr").remove();
          this.setState({ ipo: [], allIpo: [] });

          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };
  addTD(row, val, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var text = document.createTextNode(val);
    cell.append(text);
    row.append(cell);
  }
  setIpoDesignId(id) {
    this.setState({ ipoDesignId: id });
  }

  setIpoTable = (e) => {
    console.log(e.nativeEvent);
    console.log(e.nativeEvent.keyCode);
    console.log(e.nativeEvent.key);

    var filterIpoNo = $("#filterIpoNo").val().trim().toLowerCase();
    var filterBpoNo = $("#filterBpoNo").val().trim().toLowerCase();
    var filterDesignColor = $("#filterDesignColor").val().trim().toLowerCase();
    var lstIpo = this.state.allIpo;
    var tmpLstIpo = [];
    console.log("lstIpo.length=" + lstIpo.length);
    for (var i = 0; i < lstIpo.length; i++) {
      var row = lstIpo[i];

      var bpoNo = row.bpo + "";
      var ipoNo = row.ipoNo + "";
      var designNoColor = row.designColor;

      console.log("bpoNo = " + bpoNo.toLowerCase().indexOf(filterBpoNo) === -1);
      console.log("ipoNo = " + ipoNo.toLowerCase().indexOf(filterIpoNo) === -1);
      console.log(
        "designNoColor = " +
          designNoColor.toLowerCase().indexOf(filterDesignColor) ===
          -1
      );

      if (ipoNo && ipoNo.toLowerCase().indexOf(filterIpoNo) === -1) continue;
      if (bpoNo && bpoNo.toLowerCase().indexOf(filterBpoNo) === -1) continue;
      if (
        designNoColor &&
        designNoColor.toLowerCase().indexOf(filterDesignColor) === -1
      )
        continue;

      tmpLstIpo.push(row);
    }
    this.setState({ ipo: tmpLstIpo });
    tmpLstIpo = [];
  };

  render() {
    httpURL = window.httpURL;
    return (
      <div style={{ height: "100%" }}>
        <Header />
        <ToastContainer autoClose={2000} hideProgressBar />
        <div
          style={{
            position: "fixed",
            width: 100,
            height: 100,
            marginLeft: -50,
            marginTop: -50,
            left: "50%",
            top: "50%",
            display: this.state.loader,
          }}
        >
          <img src={require("../images/loader.gif")} alt="Loader..." />
        </div>
        <div className="main" style={{ opacity: this.state.opacity }}>
          <div className="container-fluid">
            <div className="col-sm-12 col-centered">
              <div
                className="col-sm-12 padding-remove"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <label htmlFor="inp_fromDate">From Date</label>
                <div style={{ marginLeft: 5, width: 100 }}>
                  <DatePicker
                    id="inp_fromDate"
                    className="form-control text-center"
                    placeholderText="From Date"
                    selected={this.state.startDate}
                    dateFormat="dd-MM-yyyy"
                    autoComplete="off"
                    onChange={(date) => {
                      this.setState({ startDate: date });
                    }}
                  />
                </div>
                <label style={{ marginLeft: 10 }} htmlFor="inp_toDate">
                  To Date
                </label>
                <div style={{ marginLeft: 5, width: 100 }}>
                  <DatePicker
                    id="inp_toDate"
                    className="form-control text-center"
                    placeholderText="To Date"
                    selected={this.state.endDate}
                    dateFormat="dd-MM-yyyy"
                    autoComplete="off"
                    onChange={(date) => {
                      this.setState({ endDate: date });
                    }}
                  />
                </div>
                <button
                  style={{ marginLeft: 20 }}
                  type="button"
                  id="getData"
                  className="btn btn-warning"
                  onClick={this.getIpo}
                >
                  Get Data
                </button>
              </div>
              <div className="col-sm-12 padding-remove">
                <table
                  className="tableLayout1"
                  style={{ width: this.state.width }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: 30, display: "none" }}>Ipo Id</th>
                      <th style={{ width: 35 }}>Cancelled On</th>
                      <th style={{ width: 25 }}>
                        <input
                          type="text"
                          onChange={(e) => {
                            this.setIpoTable(e);
                          }}
                          onKeyDown={(e) => {
                            console.log("keydown ipono");
                            this.setIpoTable(e);
                          }}
                          className="form-control inp-search"
                          id="filterIpoNo"
                          placeholder="Ipo No"
                        />
                      </th>
                      <th style={{ width: 30 }}>IPO Dt</th>
                      <th style={{ width: 60 }}>
                        <input
                          type="text"
                          onChange={(e) => {
                            this.setIpoTable(e);
                          }}
                          onKeyDown={(e) => {
                            console.log("keydown dsnc");
                            this.setIpoTable(e);
                          }}
                          className="form-control inp-search"
                          id="filterDesignColor"
                          placeholder="Design Color"
                        />
                      </th>
                      <th style={{ width: 50 }}>
                        <input
                          type="text"
                          onChange={(e) => {
                            this.setIpoTable(e);
                          }}
                          onKeyDown={(e) => {
                            console.log("keydown bpono");
                            this.setIpoTable(e);
                          }}
                          className="form-control inp-search"
                          id="filterBpoNo"
                          placeholder="Bpo No."
                        />
                      </th>
                      <th style={{ width: 30 }}>BPO Dt</th>
                      <th style={{ width: 50 }}>Buyer Length</th>
                      <th style={{ width: 30 }}>Work Done</th>
                    </tr>
                  </thead>
                </table>
                <div className="col-sm-12 ipoTableDiv padding-remove">
                  <table id="ipoTable" className="tableLayout">
                    <colgroup>
                      <col width="35" />
                      <col width="25" />
                      <col width="30" />
                      <col width="60" />
                      <col width="50" />
                      <col width="30" />
                      <col width="50" />
                      <col width="30" />
                    </colgroup>
                    <tbody id="ipoTableBody">
                      {this.state.ipo.map((obj, idx) => {
                        return (
                          <tr
                            onClick={() => this.setIpoDesignId(obj.ipoDesignId)}
                            className={
                              obj.ipoDesignId == this.state.ipoDesignId
                                ? "selected"
                                : ""
                            }
                          >
                            <td className="no-display">{obj.ipoDesignId}</td>
                            <td>{obj.deletedDttm}</td>
                            <td>{obj.ipoNo}</td>
                            <td>{obj.ipoDt}</td>
                            <td>{obj.designColor}</td>
                            <td>{obj.bpo}</td>
                            <td>{obj.bpoDt}</td>
                            <td>{obj.bpoLength}</td>
                            <td>{obj.workDone}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
